<template>
  <blockquote
    v-if="isVisible"
    class="paragraph-quote"
    :class="[
      {
        container: !parentType,
        [marginClasses]: !parentType,
      },
      globalClasses,
    ]"
  >
    <p
      v-blokkli-editable:field_text
      class="is-quote lg:max-w-prose"
      v-html="text"
    />
    <footer
      v-if="quotee"
      v-blokkli-editable:field_title
      class="mt-20 text-lg lg:text-2xl font-semibold"
    >
      {{ quotee }}
    </footer>
  </blockquote>
</template>

<script lang="ts" setup>
const { parentType, options } = defineBlokkli({
  bundle: 'quote',
  globalOptions: ['region', 'marginTop'],
  editor: {
    previewWidth: 800,
    editTitle: (el) =>
      (el.querySelector('footer') || el.querySelector('p'))?.innerText,
  },
})

const { isVisible, marginClasses, globalClasses } =
  useMappedParagraphOptions(options)

defineProps<{
  text: string
  quotee?: string
}>()
</script>

<style lang="postcss">
.paragraph-quote {
  p {
    &:before {
      content: '«';
    }
    &:after {
      content: '»';
    }
  }
}
</style>
